import Backdrop from "@/components/base/backdrop";
import PageLayout from "@/components/base/page-layout";
import withErrorBoundary from "@/components/hoc/with-error-boundary";
import Settings from "@/components/settings";
import useQueryVendor from "@/hooks/queries/useQueryVendor";

const SettingsPage: React.FC = () => {
  const { data: vendor, isFetching } = useQueryVendor();

  if (!vendor) {
    return <Backdrop loading={isFetching} />;
  }

  return (
    <PageLayout title="Settings" isForm>
      <Settings data={vendor} />
    </PageLayout>
  );
};

export default withErrorBoundary({ component: "SettingsPage" })(SettingsPage);
